import React, { useEffect, useState } from "react";
import "../FanExperienceComponent/FanExperienceComponent.css";
import { CiCircleCheck } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundForward } from "react-icons/io";
import { IoIosArrowRoundBack } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";
import { IoLocationOutline } from "react-icons/io5";
import { PiMedalLight } from "react-icons/pi";
import { TbSpeakerphone } from "react-icons/tb";
import { IoNewspaperOutline } from "react-icons/io5";
import { FaRegEye } from "react-icons/fa";
import { LuBookUser } from "react-icons/lu";
import { PiPencilDuotone } from "react-icons/pi";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import { TiHomeOutline } from "react-icons/ti";
import { IoSchoolOutline } from "react-icons/io5";
import { LuSchool } from "react-icons/lu";
import { CiCircleInfo } from "react-icons/ci";
import Loader from "../Loader/Loader";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { FiInstagram } from "react-icons/fi";
import { CiFacebook } from "react-icons/ci";
import { FiYoutube } from "react-icons/fi";
import { FiTwitter } from "react-icons/fi";
import { AiOutlineTikTok } from "react-icons/ai";
const FanExperienceComponent = () => {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { playerId, teamId } = useParams();
  const [playerDetails, setPlayerDetails] = useState(null);
  const [playerFirstName, setPlayerFirstName] = useState(null);
  const [athleteProfileData, setAthleteProfileData] = useState();

  const [pricingOptionsList, setPricingOptionsList] = useState([]);
  const defaultValueFan = ["$25+", "$25+", "$50+", "$100+", "$150+"];

  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? 270 : 400,
    bgcolor: "background.paper",
    // border: "2px solid #000",
    boxShadow: 24,
    p: isMobile ? 1 : 4,
    outline: "none",
  };
  const [selectedExperience, setSelectedExperience] = useState(null);

  const [openDetailModal, setOpenDetailModal] = React.useState(false);
  const handleOpenDetails = (engagementType) => {
    const foundData = dataFanExperience.find(
      (item) => item.fanEngagementType === engagementType
    );

    setSelectedExperience(foundData);
    setOpenDetailModal(true);
  };

  const handleCloseDetails = () => {
    setOpenDetailModal(false);
  };

  const dataFanExperience = [
    {
      fanEngagementType: "generalSupport",
      title: "General Collaboration",
      platforms: [
        "Instagram",
        "TikTok",
        "Facebook",
        "YouTube",
        "X (Twitter)",
        "LinkedIn",
      ],
      description: `${playerFirstName} will engage with your content by subscribing, following, liking, or sharing it with their social-media followers on the designated platform.
        
        For example, if Instagram is selected as the platform and the athlete has over 15K followers, your content may be seen by their audience, helping expand your reach.`,
      specialInstructionsLabel: "Special Instructions:",
      pricingOptions: pricingOptionsList?.generalSupport?.options
        ? pricingOptionsList?.generalSupport?.options
        : [
            {
              pricingText: "Like ($25) per post",
              pricingValue: "$25",
            },
            {
              pricingText: "Follow/Subscribe ($25)",
              pricingValue: "$25",
            },
            {
              pricingText: "Comment ($75) per post",
              pricingValue: "$75",
            },
            {
              pricingText: "Share your channel ($150)",
              pricingValue: "$150",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "personalizedPost",
      title: "Personalized Post",
      platforms: [
        "Instagram",
        "TikTok",
        "Facebook",
        "YouTube",
        "X (Twitter)",
        "LinkedIn",
      ],
      description: `${playerFirstName} will post a personalized message on your selected platform. Occasions may include: Birthday, Motivational, Congratulations, Holidays, or Other.

For example, if Instagram is selected as the platform and the athlete has over 15K followers, your message will reach that audience, giving your post added visibility and engagement.`,
      specialInstructionsLabel: "Create your custom message",
      pricingOptions: pricingOptionsList?.personalizedPost?.options
        ? pricingOptionsList?.personalizedPost?.options
        : [
            {
              pricingText: "Under 50 words ($25)",
              pricingValue: "$25",
            },
            {
              pricingText: "50–100 words +$50",
              pricingValue: "+${50}",
            },
            {
              pricingText: "100–150 words +$75",
              pricingValue: "+${75}",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "personalizedVideo",
      title: "Personalized Video Message",
      platforms: [
        "Instagram",
        "TikTok",
        "Facebook",
        "YouTube",
        "X (Twitter)",
        "LinkedIn",
      ],
      description: `${playerFirstName} will record a personalized video message on your selected platform.

For example, if Instagram is selected as the platform and the athlete has over 15K followers, your video message can be shared with that audience for greater visibility and engagement.

Provide a topic or short instructions for the message.`,
      specialInstructionsLabel: "Create custom video message",
      pricingOptions: pricingOptionsList?.personalizedVideo?.options
        ? pricingOptionsList?.personalizedVideo?.options
        : [
            {
              pricingText: "Under 30 sec ($50)",
              pricingValue: "$50",
            },
            {
              pricingText: "30 sec–1 min +$50",
              pricingValue: "+${50}",
            },
            {
              pricingText: "Over 1 min (inquire)",
              pricingValue: "inquire",
            },
            {
              pricingText: "Multiple Requests (please specify)",
              pricingValue: "custom",
            },
          ],
    },
    {
      fanEngagementType: "meetGreet",
      title: "Virtual Meet & Greet",
      platforms: [
        "Instagram",
        "TikTok",
        "Facebook",
        "Twitch",
        "YouTube",
        "X (Twitter)",
        "LinkedIn",
        "Zoom",
      ],
      description: `Join ${playerFirstName} in a virtual live session or video chat.
Participate in Q&A sessions, polls, and interactive discussions.

Details depend on availability. (${playerFirstName} will send a notification with specific dates and times once confirmed.)

*Tip: Encourage friends and fans to sign up as strong fan interest increases the chances of this live event happening!`,
      specialInstructionsLabel: "",
      pricingOptions: pricingOptionsList?.meetGreet?.options
        ? pricingOptionsList?.meetGreet?.options
        : [
            {
              pricingText: "15 min ($100)",
              pricingValue: "$100",
            },
            {
              pricingText: "30 min +$100",
              pricingValue: "+${100}",
            },
            {
              pricingText: "Over 30 min (inquire)",
              pricingValue: "inquire",
            },
          ],
    },
    {
      fanEngagementType: "personInteraction",
      title: "In-Person Meet & Greet",
      platforms: [
        "Autograph",
        "Photo Opp",
        "Meet & Greet",
        "Fundraiser",
        "Other",
      ],
      description: `${playerFirstName} will attend in-person events such as autograph sessions, photo opportunities, or meet & greets.

Details depend on availability. (${playerFirstName} will send a notification with specific dates and times once confirmed.)

*Tip: Encourage friends and fans to sign up as strong fan interest increases the chances of this in-person appearance!`,
      specialInstructionsLabel: "",
      pricingOptions: pricingOptionsList?.personInteraction?.options
        ? pricingOptionsList?.personInteraction?.options
        : [
            {
              pricingText: "5 min per person ($150)",
              pricingValue: "$150",
            },
            {
              pricingText: "Over 5 min (inquire)",
              pricingValue: "inquire",
            },
          ],
    },
  ];

  const navigate = useNavigate();
  const openSlider = (index) => {
    setCurrentIndex(index);
    setIsSliderOpen(true);
  };
  const closeSlider = () => setIsSliderOpen(false);
  const nextSlide = () => {
    setCurrentIndex(
      (prev) => (prev + 1) % (athleteProfileData?.images?.length || 1)
    );
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prev) =>
        (prev - 1 + (athleteProfileData?.images?.length || 1)) %
        (athleteProfileData?.images?.length || 1)
    );
  };
  // api stuff
  const getPlayerDetails = () => {
    setLoading(true);

    const url = `${APIUrl()}/v1/get_player/${playerId}/${teamId}`;
    const options = {
      method: "GET",
      headers: { "X-API-Key": APIUrlToken() },
    };
    axios(url, options)
      .then((response) => {
        setPlayerDetails(response?.data);
        setPlayerFirstName(response?.data?.player_name?.split(" ")[0]);
        setAthleteProfileData(response?.data?.athlete_profile);
      })
      .catch((error) => {
        console.error("Error fetching player data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getPlayerDetails();
  }, [playerId, teamId]);

  const getPricingListOptions = () => {
    const url = `${APIUrl()}/v1/fan_engagement_pricing/by_player/${playerId}`;
    const option = {
      method: "GET",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      url: url,
    };

    axios(option)
      .then((response) => {
        const data = response?.data || [];
        setPricingOptionsList(data?.config || {});
        // window.location.href = data
      })
      .catch((error) => {
        console.error("Error fetching teams data:", error);
      });
  };
  useEffect(() => {
    getPricingListOptions();
  }, []);
  const getUsername = (url) => {
    if (!url) return "";
    return url.split(".com/")[1] || url; // fallback if format is different
  };
  // const socials = [
  //   {
  //     icon: <FiInstagram />,
  //     url: playerDetails?.athlete_profile?.instagram_url,
  //   },
  //   {
  //     icon: <CiFacebook />,
  //     url: playerDetails?.athlete_profile?.facebook_url,
  //   },
  //   {
  //     icon: <FiYoutube />,
  //     url: playerDetails?.athlete_profile?.youtube_url,
  //   },
  //   {
  //     icon: <FiTwitter />,
  //     url: playerDetails?.athlete_profile?.twitter_url,
  //   },
  //   {
  //     icon: <AiOutlineTikTok />,
  //     url: playerDetails?.athlete_profile?.tiktok_url,
  //   },
  // ];

  const formatUrl = (value, type) => {
    if (!value) return "";

    // Already a full URL
    if (value.startsWith("http")) return value;

    const baseUrls = {
      instagram: "https://instagram.com/",
      facebook: "https://facebook.com/",
      youtube: "https://youtube.com/",
      twitter: "https://twitter.com/",
      tiktok: "https://tiktok.com/@",
    };

    return baseUrls[type] + value;
  };

  const socials = [
    {
      icon: <FiInstagram />,
      url: formatUrl(
        playerDetails?.athlete_profile?.instagram_url,
        "instagram"
      ),
    },
    {
      icon: <CiFacebook />,
      url: formatUrl(playerDetails?.athlete_profile?.facebook_url, "facebook"),
    },
    {
      icon: <FiYoutube />,
      url: formatUrl(playerDetails?.athlete_profile?.youtube_url, "youtube"),
    },
    {
      icon: <FiTwitter />,
      url: formatUrl(playerDetails?.athlete_profile?.twitter_url, "twitter"),
    },
    {
      icon: <AiOutlineTikTok />,
      url: formatUrl(playerDetails?.athlete_profile?.tiktok_url, "tiktok"),
    },
  ];

  return (
    <div>
      {loading ? <Loader /> : null}

      <div className="arrow-go-back-fan">
        <p onClick={() => navigate("/dashboard/start-your-fan-experience")}>
          <IoIosArrowRoundBack />
        </p>
        <p
          className="go-back-fan"
          onClick={() => navigate("/dashboard/start-your-fan-experience")}
        >
          Go Back
        </p>
      </div>
      <div
        className={
          athleteProfileData?.images
            ? "image-section-fan-experience"
            : "image-section-fan-experience-none"
        }
      >
        {(() => {
          const imageArray = Array.isArray(athleteProfileData?.images)
            ? athleteProfileData.images
            : athleteProfileData?.images
            ? [athleteProfileData.images]
            : [];

          return imageArray.length > 0
            ? imageArray
                .slice(0, 5)
                .map((img, i) => (
                  <img
                    key={i}
                    src={`data:image/jpeg;base64,${img}`}
                    alt={`fan-img-${i}`}
                    onClick={() => openSlider(i)}
                    className="fan-gallery-img"
                  />
                ))
            : "";

          // <p className="no-image-available">No image available</p>
        })()}

        {/* Show "View all" button only if more than 5 images exist */}
        {Array.isArray(athleteProfileData?.images) &&
          athleteProfileData.images.length > 5 && (
            <button
              className="view-all-btn-fan-ex"
              onClick={() => openSlider(0)}
            >
              View all
            </button>
          )}
      </div>

      {/* ✅ Image Slider */}
      {isSliderOpen && (
        <div className="fan-slider-overlay">
          {(() => {
            const imageArray = Array.isArray(athleteProfileData?.images)
              ? athleteProfileData.images
              : athleteProfileData?.images
              ? [athleteProfileData.images]
              : [];

            return (
              <>
                {/* Progress bar container */}
                <div className="fan-progress-bar-container">
                  {imageArray.map((_, index) => (
                    <div
                      key={index}
                      className={`fan-progress-segment ${
                        index === currentIndex
                          ? "fan-progress-active"
                          : index < currentIndex
                          ? "fan-progress-completed"
                          : ""
                      }`}
                    ></div>
                  ))}
                </div>

                <button onClick={closeSlider} className="close-btn-fan">
                  <RxCross1 size={32} />
                </button>

                <button onClick={prevSlide} className="prev-btn-fan">
                  <IoIosArrowRoundBack size={48} />
                </button>

                <img
                  src={`data:image/jpeg;base64,${imageArray[currentIndex]}`}
                  alt="fan-slider"
                  className="fan-slider-img"
                />

                <button onClick={nextSlide} className="next-btn-fan">
                  <IoIosArrowRoundForward size={48} />
                </button>
              </>
            );
          })()}
        </div>
      )}
      <div className="for-all-info-fan-experience">
        <div className="for-details-fan-experience">
          <div className="for-details-fan-experience-inner">
            <div className="profile-image-fan-experience">
              <img
                className="profile-image-fan-experience-inner"
                src={playerDetails?.image_url}
                alt=""
              />
            </div>
            <div className="name-deatils-fan-experience">
              <p className="name-deatils-fan-experience-inner">
                {playerDetails?.player_name}
              </p>
              <p className="player-sport-fan-ex">
                {playerDetails?.team_name ? playerDetails?.team_name : ""}

                {playerDetails?.sport_name
                  ? ` • ${playerDetails.sport_name}`
                  : ""}
                {playerDetails?.position ? ` • ${playerDetails.position}` : ""}
                {playerDetails?.jersey_number
                  ? ` • #${playerDetails.jersey_number}`
                  : ""}
              </p>

              <div className="player-sport-fan-ex-links-main">
                {socials
                  .filter((item) => item.url) // remove empty urls
                  .map((item, index) => {
                    const username = getUsername(item.url);

                    return (
                      <p className="player-sport-fan-ex-links" key={index}>
                        {item.icon}
                        <a
                          href={item.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-link"
                        >
                          {username}
                        </a>
                      </p>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="about-section-start-dan-ex">
            <p className="about-section-start-dan-ex-inner">
              Athlete's Profile
            </p>
            <div className="main-icon-and-detail-ex">
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <TiHomeOutline />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">Birthplace:</p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {playerDetails?.birthplace}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <IoSchoolOutline />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    High School:{" "}
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.high_school}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <LuSchool />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Previous School:{" "}
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.previous_school}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <CiCircleInfo />
                </div>

                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Summary (Bio):{" "}
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.summary}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <PiMedalLight />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Accolades & Awards:
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {athleteProfileData?.accolades}
                  </p>
                </div>
              </div>
              <div className="icon-and-detail-ex">
                <div className="affiliations-details-fan-ex-icon">
                  <IoLocationOutline />
                </div>
                <div className="detail-response-engagement">
                  <p className="sub-affiliations-details-fan-ex">
                    Preferred Locations:
                  </p>{" "}
                  <p className="affiliations-details-fan-ex">
                    {/* {athleteProfileData?.location} */}
                    {athleteProfileData?.preferred_locations?.map(
                      (loc, index) => (
                        <span key={index}>
                          {loc} <br />
                        </span>
                      )
                    )}{" "}
                  </p>
                </div>
              </div>{" "}
            </div>
          </div>

          <div className="about-section-start-outer">
            <p className="about-section-start-dan-ex-inner">
              Interests / Hobbies
            </p>
            <div className="main-icon-and-detail-ex">
              <div className="Interests-elements-container">
                {athleteProfileData?.interests?.length > 0 ? (
                  athleteProfileData.interests.map((interest, index) => (
                    <p key={index}>
                      <CiCircleCheck /> {interest}
                    </p>
                  ))
                ) : (
                  <p>No Interests / Hobbies available</p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="for-personal-detail-fan-experience">
          <p className="for-personal-use-heading">
            Select the engagement option from the available services below:
          </p>
          <p className="for-personal-use-heading-new">
            (for personal use only)
          </p>{" "}
          {/* <p className="for-personal-use-heading">(for personal use only)</p>{" "} */}
          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <TbSpeakerphone />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    General Collaboration{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("generalSupport")}
                    >
                      More Details
                    </span>
                  </p>

                  <p className="inner-text-personal-ex-second">
                    {pricingOptionsList?.generalSupport?.sectionValue ||
                      defaultValueFan[0]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} will engage and collaborate on your social
                    media page/post
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/FanEngagementType", {
                    state: {
                      dataFanExperience: dataFanExperience,
                      checkoutType: "General Collaboration",
                      playerName: playerFirstName,
                      type: "generalSupport",
                      playerId: playerId,
                      teamId: teamId,
                      pricingOptionsList: pricingOptionsList,
                      sectionValue:
                        pricingOptionsList?.generalSupport?.sectionValue ||
                        defaultValueFan[0],
                    },
                  })
                }
              >
                Start Your Fan Experience
              </button>
            </div>
          </div>
          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <IoNewspaperOutline />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Personalized Post{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("personalizedPost")}
                    >
                      More Details
                    </span>
                  </p>

                  <p className="inner-text-personal-ex-second">
                    {pricingOptionsList?.personalizedPost?.sectionValue ||
                      defaultValueFan[1]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} will send a Personalized Post
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/FanEngagementType", {
                    state: {
                      dataFanExperience: dataFanExperience,
                      checkoutType: "Personalized Post",
                      type: "personalizedPost",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      pricingOptionsList: pricingOptionsList,
                      sectionValue:
                        pricingOptionsList?.personalizedPost?.sectionValue ||
                        defaultValueFan[1],
                    },
                  })
                }
              >
                Start Your Fan Experience
              </button>
            </div>
          </div>
          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <FaRegEye />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Personalized Video Message{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("personalizedVideo")}
                    >
                      More Details
                    </span>{" "}
                  </p>

                  <p className="inner-text-personal-ex-second">
                    {pricingOptionsList?.personalizedVideo?.sectionValue ||
                      defaultValueFan[2]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} will send a Personalized Video Message
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/FanEngagementType", {
                    state: {
                      dataFanExperience: dataFanExperience,
                      checkoutType: "Personalized Video Message",
                      type: "personalizedVideo",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      pricingOptionsList: pricingOptionsList,
                      sectionValue:
                        pricingOptionsList?.personalizedVideo?.sectionValue ||
                        defaultValueFan[2],
                    },
                  })
                }
              >
                Start Your Fan Experience
              </button>
            </div>
          </div>
          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <LuBookUser />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    Virtual Meet & Greet{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("meetGreet")}
                    >
                      More Details
                    </span>{" "}
                  </p>

                  <p className="inner-text-personal-ex-second">
                    {pricingOptionsList?.meetGreet?.sectionValue ||
                      defaultValueFan[3]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} will participate in a Virtual Meet & Greet
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/FanEngagementType", {
                    state: {
                      dataFanExperience: dataFanExperience,
                      checkoutType: "Virtual Meet & Greet",
                      type: "meetGreet",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      pricingOptionsList: pricingOptionsList,
                      sectionValue:
                        pricingOptionsList?.meetGreet?.sectionValue ||
                        defaultValueFan[3],
                    },
                  })
                }
              >
                Start Your Fan Experience
              </button>
            </div>
          </div>
          <div className="for-personal-use">
            <div>
              <div className="fan-inner-for-personal-use">
                <div className="only-icon-p-details-ex">
                  <PiPencilDuotone />{" "}
                </div>
                <div className="inner-text-personal-ex">
                  <p className="inner-text-personal-ex-first">
                    In-Person Meet & Greet{" "}
                    <span
                      className="inner-text-personal-ex-first-link"
                      onClick={() => handleOpenDetails("personInteraction")}
                    >
                      More Details
                    </span>
                  </p>

                  <p className="inner-text-personal-ex-second">
                    {pricingOptionsList?.personInteraction?.sectionValue ||
                      defaultValueFan[4]}
                  </p>
                  <p className="inner-text-personal-ex-three">
                    {playerFirstName} will participate in an In-Person Meet &
                    Greet
                  </p>
                </div>
              </div>
              <button
                className="personal-use-inner-buttons"
                onClick={() =>
                  navigate("/FanEngagementType", {
                    state: {
                      dataFanExperience: dataFanExperience,
                      checkoutType: "In-Person Meet & Greet",
                      type: "personInteraction",
                      playerId: playerId,
                      teamId: teamId,
                      playerName: playerFirstName,
                      pricingOptionsList: pricingOptionsList,
                      sectionValue:
                        pricingOptionsList?.personInteraction?.sectionValue ||
                        defaultValueFan[4],
                    },
                  })
                }
              >
                Start Your Fan Experience
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal open={openDetailModal} onClose={handleCloseDetails}>
        <Box sx={style}>
          <Typography
            variant="h6"
            style={{ fontSize: isMobile ? "16px" : "18px" ,
              fontWeight: 600,
            }}
          >
            {selectedExperience?.title}
          </Typography>

          <Typography sx={{ mt: 2 }}>
            <div
              style={{ fontSize: isMobile ? "14px" : "18px" }}
              className="fan-description"
              dangerouslySetInnerHTML={{
                __html: selectedExperience?.description?.replace(
                  /\n/g,
                  "<br/>"
                ),
              }}
            />
          </Typography>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="engagement-modal-close-btn"
              onClick={handleCloseDetails}
            >
              Close
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default FanExperienceComponent;
